import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Navbar } from "./Navbar";
import { BottomNav } from "./BottomNav";
import { Footer } from "./Footer";
import { SeoManager } from "../SeoManager";
import { CookieConsent } from "../CookieConsent";
import { trackVisit, trackClick } from "../../lib/analytics";

export const Layout = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    trackVisit();
  }, [location.pathname]);

  useEffect(() => {
    const handler = (e) => {
      if (e.target.closest("a, button, [role='button']")) trackClick();
    };
    document.addEventListener("click", handler, true);
    return () => document.removeEventListener("click", handler, true);
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-stone-bg">
      <SeoManager />
      <CookieConsent />
      <Navbar />
      <main className="flex-1 pb-20 md:pb-0">
        <Outlet />
      </main>
      <Footer />
      <BottomNav />
    </div>
  );
};
